module.exports = __webpack_public_path__ + "76cc6be5d8a231dc012fef4bdb86f79c.ttf";